import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { Input, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import { useNavigate } from 'react-router-dom';
import { createLearningBook, findLearningBookById, updateLearningBook } from '../../../../service/learningBookService';
import { LearningAssetStatus, LearningBookRequest } from '../../../../model/request';
import toast, { NotifyType } from '../../../../utils/toast';
import HeaderAction from '../HeaderAction';
import { learningBookStatusList } from '../../../../utils/enumMapper';

function LearningBookForm() {
  const { id } = useParams();
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [schoolLevel, setSchoolLevel] = useState('');
  const [group, setGroup] = useState('');
  const [grade, setGrade] = useState('');
  const [status, setStatus] = useState<LearningAssetStatus | null>('ACTIVE');

  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      findLearningBookById(id)
        .then((learningBook) => {
          setName(learningBook.name);
          setDescription(learningBook.description || '');
          setSchoolLevel(learningBook.schoolLevel || '');
          setGroup(learningBook.group || '');
          setGrade(learningBook.grade || '');
          setStatus(learningBook.status ?? null);
        })
        .catch((e) => console.error(e));
    }
  }, [id]);

  function handleGoBack() {
    navigate('/learning-assets/learning-books');
  }

  async function handleSubmit() {
    try {
      const learningBookRequest: LearningBookRequest = {
        name,
        description,
        schoolLevel,
        group,
        grade,
        status: status || undefined,
      };
      id ? await updateLearningBook(id, learningBookRequest) : await createLearningBook(learningBookRequest);
      toast(NotifyType.INFO, id ? 'Cập nhật sách thành công' : 'Tạo sách thành công');
      navigate('/learning-assets/learning-books');
    } catch (err) {
      console.error(err);
      toast(NotifyType.ERROR, id ? 'Cập nhật sách không thành công' : 'Tạo sách không thành công');
    }
  }

  return (
    <div className={'w-full h-full bg-white flex flex-col'}>
      <HeaderAction handleGoBack={handleGoBack} handleSubmit={handleSubmit} />
      <div className={'w-full p-8 h-[calc(100vh-160px)] overflow-y-auto'}>
        <h2 className={'font-bold text-xl'}>{id ? 'Chỉnh sửa sách' : 'Thêm sách mới'}</h2>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Tên sách:</div>
          <Input className="flex-1" name={'name'} value={name} onChange={(e) => setName(e.target.value)} />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Mô tả chi tiết:</div>
          <TextArea
            className="flex-1"
            name={'description'}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={6}
          />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Cấp học:</div>
          <Input
            className="flex-1"
            name={'schoolLevel'}
            value={schoolLevel}
            onChange={(e) => setSchoolLevel(e.target.value)}
          />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Bộ sách:</div>
          <Input className="flex-1" name={'group'} value={group} onChange={(e) => setGroup(e.target.value)} />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Lớp:</div>
          <Input className="flex-1" name={'grade'} value={grade} onChange={(e) => setGrade(e.target.value)} />
        </div>
        <div className="flex items-center mt-2">
          <div className="text-[18px] w-[20%] text-left">Trạng thái:</div>
          <Select
            onChange={(value) => setStatus(value)}
            className="w-full"
            placeholder="Trạng thái"
            style={{ flex: 1 }}
            value={status}
            options={learningBookStatusList}
          />
        </div>
      </div>
    </div>
  );
}

export default LearningBookForm;
